"use client";

import { ViewSeo } from "@ctv/shared-core/src";
import { PropsWithChildren, useEffect, useState } from "react";
import { Dimensions, SafeAreaView, StyleSheet } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export default function Wrapper(props: PropsWithChildren<unknown>) {
  const { children } = props;
  const insets = useSafeAreaInsets();

  const [height, setHeight] = useState(Dimensions.get("window").height);

  useEffect(() => {
    const onChange = ({ window }: { window: { height: number } }) => {
      setHeight(window.height);
    };

    const subscription = Dimensions.addEventListener("change", onChange);
    return () => subscription.remove();
  }, []);

  const viewportHeight = height - insets.top - insets.bottom;

  return (
    <SafeAreaView style={styles.safeArea}>
      <ViewSeo id="screenWrapper" style={{ minHeight: viewportHeight }}>
        {children}
      </ViewSeo>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
  },
});
